module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('span', {
    staticClass: "big1"
  }, [_vm._v("THE")]), _c('br'), _c('br'), _c('span', {
    staticClass: "big"
  }, [_vm._v("ENTITY")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/9780312375942_001.png"
    }
  }), _c('br'), _c('br'), _vm._v("FIVE CENTURIES"), _c('br'), _vm._v("OF SECRET VATICAN"), _c('br'), _vm._v("ESPIONAGE")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("ERIC FRATTINI")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Translated by Dick Cluster")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("ST. MARTIN’S PRESS")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/9780312375942_tit.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f6ae68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312375942_epub_tp_r1.vue
// module id = 60
// module chunks = 0